<template>
    <div class="datepicker-holder skiptranslate" ref="datePickerHolder" @keydown="datePickerKeyEvent">
        <v-date-picker
            v-show="calendarExists"
            :firstDayOfWeek="2"
            
            :min-page="minPage"    
            :max-page="maxPage"    
            :available-dates="availableEntitledDates"
            :disabled-dates="disabledDates"
            v-bind:color="calendarColor"

            v-model="selectedPeriod"
            :mode="mode"

            is-inline
            is-expanded
            :attributes="attributes"
            @dayclick="datePickerClick"
            ref="vDatePicker"
        />
    </div>
</template>

<script>
import DateChecker from '../../../../common/utils/DateChecker'
import DateNoTz from '../../../../common/utils/DateNoTz'
import ServerDateMixin from '../../../../common/mixins/ServerDateMixin'

export default {
    mixins: [ServerDateMixin],
    props: {
        periodType : { // Is Either daily or weekly
            type: String,
            default : "daily"
        },
        dateFilter : {
            type: Object,
            default : {
                availableEntitledDates : [],
            }
        },
        selectionOptions : {
            type: Object,
            default : {
                weekly_start_day : 1,
                weekly_end_day  : 5
            }
        },
        attributes: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            selectedPeriod : null,
            calendarExists : true,

            availableEntitledDates : [],
            disabledDates : { weekdays : [1, 2, 3, 4, 5, 6, 7] },
            minPage : null,
            maxPage : null,

            cachedDateFilterString : null
        }
    },
    computed : {
        mode : function(){
            return (this.periodType == "weekly" || this.periodType == "predefined_week") ? "range" : "single"
        },
        calendarColor : function(){
            return this.$store.getters["GET_MAIN_UI"].calendar_color;
        }
    },
    watch : {
        dateFilter : function(dateFilter){

            if(!this.dateFilter || !this.dateFilter.availableEntitledDates || this.dateFilter.availableEntitledDates.length == 0){
                this.availableEntitledDates = [];
                this.disabledDates = {
                    weekdays : [1, 2, 3, 4, 5, 6, 7] // disable the calendar
                }
                var serverDate = this.getServerDate()
                var date = new DateNoTz(serverDate)
                date = date.asJsDate();
                var range = {
                    month : date.getMonth() + 1,
                    year : date.getFullYear()
                }
                this.minPage = range;
                this.maxPage = range;
            }
            else {
                this.availableEntitledDates = this.dateFilter.availableEntitledDates;
                this.disabledDates = []
                this.minPage = {
                    month : this.availableEntitledDates[0].getMonth() + 1,
                    year : this.availableEntitledDates[0].getFullYear()
                };
                this.maxPage = {
                    month :  this.availableEntitledDates[this.availableEntitledDates.length -1].getMonth() + 1,
                    year :  this.availableEntitledDates[this.availableEntitledDates.length -1].getFullYear()
                };
            }

            /**
            * DEF_050_Multi service: Date not captured when select-deselect level 2
            * When woi waste selection is enabled and multiservice. The selected date
            * wont persist when 2 waste streams is selected and were selecting and deselecting
            * between their woi wastes
            */
            if (this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED
                && this.selectedPeriod
                && !this.$store.getters.GET_CURRENT_SERVICE_DATES.length) {
                this.$store.dispatch('setActiveMultipleServiceSelectedBookingPeriods', { selectedPeriod: this.selectedPeriod });
            }

            // Practice Caching so you don't have to run this operation all the time
            if(this.cachedDateFilterString && JSON.stringify(dateFilter) === this.cachedDateFilterString){
                return
            }
            else{
                this.cachedDateFilterString = JSON.stringify(dateFilter)
            }

            var self = this;

            setTimeout(
                // Evaluate seleciton here since this.selectedPeriod doesn't always refresh
                function(){
                    var userHasMadeSelection = self.selectedPeriod && self.periodType ==- 'predefined_day'
                    if(self.calendarExists && self.$refs.vDatePicker && !userHasMadeSelection){
                        if(self.$refs.vDatePicker){
                            self.$refs.vDatePicker.$children[0].move(self.minPage)
                        }
                    }
                }
            , 200)
        
        },
    },
    mounted(){
        this.$parent.$on("transactionStateUpdate", ()=>{ // Receives Updates from Parent
            if(!this.transactionState || !this.transactionState.entitlementSummary){
                return;
            }
            else if(this.transactionState.selectedService && (!this.selectedServiceId || this.selectedServiceId != this.transactionState.selectedService.service_setting_id)){
                var selectedService = this.transactionState.selectedService;
                
                this.isSelected = selectedService != null
                this.selectedServiceId = selectedService.service_setting_id;
                this.periodType = selectedService ? selectedService.date_selection : '';
                this.is_preparation_note = selectedService ? selectedService.is_preparation_note : 0;2
                this.is_generate_pickup_date = selectedService ? selectedService.is_generate_pickup_date : 0;
                this.selectedServiceId = this.transactionState.selectedService.service_setting_id;

                var dateChecker = new DateChecker();
                this.dateFilter = dateChecker.mergePeriods(this.transactionState.entitlementSummary.currentPeriod,this.transactionState.entitlementSummary.nextPeriod);
                this.periodSelected(null)
            }
        });
    },
    methods : {
        datePickerClick(event){
            var period = new Date(event.id); 
            this.parseSelectedPeriod(period)
        },
        datePickerKeyEvent(event){
            if (event.keyCode == 13) {
                event.preventDefault();

                var datePickerRef = this.$refs.vDatePicker
                var period

                if(datePickerRef.dragValue){
                    period= new DateNoTz(datePickerRef.dragValue.start).asJsDate()
                }
                else if(datePickerRef.value){ 
                    // Make sure it's a Date Object
                    if(typeof datePickerRef.value.getMonth === 'function'){
                        period = new DateNoTz(datePickerRef.value).asJsDate()
                    }
                    else{
                        return // Abort Immediately
                    }
                }
                else { // Neither have value
                    period = null
                }
                
                this.parseSelectedPeriod(period)
            }
        },
        parseSelectedPeriod(period){
            if(this.periodType == "weekly" || this.periodType == "predefined_week"){
                var dateChecker = new DateChecker();
                var weekOfClicked = dateChecker.getWeekOfDate(period);

                // Check Selection Options of Week Options
                var weekly_start_day = 1, weekly_end_day  = 5
                if(this.selectionOptions){
                    weekly_start_day = this.selectionOptions.weekly_start_day
                    weekly_end_day  = this.selectionOptions.weekly_end_day 
                }
                period =  {
                    start : weekOfClicked[weekly_start_day],
                    end : weekOfClicked[weekly_end_day ]
                }
            }

            this.selectedPeriod = period;

            // End Selection of Date Picker
            this.$refs.datePickerHolder.click()
            setTimeout(() => {
                this.$refs.datePickerHolder.click()
            }, 50);

            // Emit
            this.$emit("periodSelected", this.selectedPeriod);
            if (!this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) return;
            this.$store.dispatch('setActiveMultipleServiceSelectedBookingPeriods', { selectedPeriod: this.selectedPeriod });
        },
        forceSelectPeriod(period){
            this.selectedPeriod = period;

            this.$refs.datePickerHolder.click()
            setTimeout(() => {
                this.$refs.datePickerHolder.click() // For iOS browsers that miss the initial event
            }, 50);
            this.$emit("periodSelected", this.selectedPeriod);
        },

        reset(){
            this.selectedPeriod = null;

            // Since every switch to service resets the datepicker, we run the prefill of selected booking date here.
            const savedPeriodDetails = this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED && this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_DATES
                .find(periodDetails =>
                    periodDetails.service_group_id === this.$store.getters.GET_ACTIVE_SERVICE_GROUP.service_group_id
                    && periodDetails.service_setting_id === this.$store.getters.GET_ACTIVE_SERVICE_SETTING.service_setting_id);

            if (savedPeriodDetails) {
                this.forceSelectPeriod(savedPeriodDetails.selectedPeriod);
            }
        }
    }
}
</script>